<template>
  <div class="page bg-color">
    <div class="asset-container">
      <div class="tabs">
        <div class="tabs-item" :class="{ active: active == 1 }" @click="active = 1"> {{ t('asset.a1') }} </div>
        <span class="yanjing">
          <van-icon @click="isShowAmount = !isShowAmount" class="icon" :name="isShowAmount ? 'eye' : 'closed-eye'"
            style="color: rgb(153, 153, 153);" />
        </span>
      </div>
      <div class="all-asset-text">
        <div class="item">
          <div class="all-asset-text-value" v-if="isShowAmount">
            <p>{{ pageData.total_price }} {{ active ? '$' : 'ARS' }}</p>
            <!-- <div class="yval"> ≈ {{ formatUnit('USD') }} {{ exchangeRateConvert(pageData.total_price, rate, true) }}
            </div> -->
          </div>
          <div class="all-asset-text-value" v-else>******</div>
        </div>
      </div>
      <div class="list">
        <div class="item">
          <div class="asset-echart-legend-item-container" style="background: rgb(245, 247, 250);">
            <div class="legend-info">
              <span class="iot" style="background: rgb(41, 119, 179);"></span>
              <span>{{ t('asset.a2') }}</span>
            </div>
            <div class="funds-value" style="color: rgb(41, 119, 179);" v-if="isShowAmount">
              <p>{{ pageData.stock_price_all }} {{ active ? '$' : 'ARS' }}</p>
              <!-- <div class="yval"> ≈ {{ formatUnit('USD') }} {{ exchangeRateConvert(pageData.stock_price_all, rate, true)
              }}</div> -->
            </div>
            <div class="funds-value" style="color: rgb(41, 119, 179);" v-else> ******</div>
          </div>
        </div>
        <div class="item">
          <div class="asset-echart-legend-item-container" style="background: rgb(245, 250, 250);">
            <div class="legend-info"><span class="iot" style="background: rgb(41, 161, 179);"></span><span>{{
              t('asset.a3') }}</span>
            </div>
            <div class="funds-value" style="color: rgb(41, 161, 179);" v-if="isShowAmount">
              <p>{{ pageData.balance_ar }} {{ active ? '$' : 'ARS' }}</p>
              <!-- <div class="yval"> ≈ {{ formatUnit('USD') }} {{ exchangeRateConvert(pageData.balance_ar, rate, true)
              }}</div> -->
            </div>
            <div class="funds-value" style="color: rgb(41, 161, 179);" v-else> ****** </div>
          </div>
        </div>
        <div class="item">
          <div class="asset-echart-legend-item-container" style="background: rgb(247, 245, 250);">
            <div class="legend-info"><span class="iot" style="background: rgb(41, 68, 179);"></span><span>{{
              t('asset.a4') }}</span>
            </div>
            <div class="funds-value" style="color: rgb(41, 68, 179);" v-if="isShowAmount">
              <p> {{ pageData.use_price }} {{ active ? '$' : 'ARS' }}</p>
              <!-- <div class="yval"> ≈ {{ formatUnit('USD') }} {{ exchangeRateConvert(pageData.use_price, rate, true) }}
              </div> -->
            </div>
            <div class="funds-value" style="color: rgb(41, 68, 179);" v-else> ****** </div>
          </div>
        </div>
        <div class="item">
          <div class="asset-echart-legend-item-container" style="background: rgb(245, 250, 247);">
            <div class="legend-info"><span class="iot" style="background: rgb(41, 179, 138);"></span><span>{{
              t('asset.a5') }}</span>
            </div>
            <div class="funds-value" style="color: rgb(41, 179, 138);" v-if="isShowAmount">
              <p>{{ pageData.income_ar }} {{ active ? '$' : 'ARS' }}</p>
              <!-- <div class="yval"> ≈ {{ formatUnit('USD') }} {{ exchangeRateConvert(pageData.income_ar, rate, true) }}
              </div> -->
            </div>
            <div class="funds-value" style="color: rgb(41, 179, 138);" v-else> ****** </div>
          </div>
        </div>
      </div>
    </div>
    <div class="asset-links">
      <!-- <div class="asset-links-item" @click="tradeType(1)"> -->
        <div class="asset-links-item" @click="openService">
        <div class="left">
          <img src="@/assets/images/cz.svg" alt="" class="icon">
          <span class="link-text">{{ t('asset.a6') }}</span>
        </div>
        <div class="right">
          <img src="@/assets/images/rgjt.png" class="img" alt="">
        </div>
      </div>
      <div class="asset-links-item" @click="tradeType(2)">
        <div class="left">
          <img src="@/assets/images/tx.svg" alt="" class="icon">
          <span class="link-text">{{ t('asset.a7') }}</span>
        </div>
        <div class="right">
          <img src="@/assets/images/rgjt.png" class="img" alt="">
        </div>
      </div>
      <div class="asset-links-item" @click="router.push('/fundingRecords')">
        <div class="left">
          <img src="@/assets/images/zjjl.svg" alt="" class="icon">
          <span class="link-text">{{ t('asset.a9') }}</span>
        </div>
        <div class="right">
          <img src="@/assets/images/rgjt.png" class="img" alt="">
        </div>
      </div>
      <!-- <div class="asset-links-item" @click="router.push('/assetConversion')">
        <div class="left">
          <img src="@/assets/images/zcjh.png" alt="" class="icon">
          <span class="link-text">{{t('asset.a8')}}</span>
        </div>
        <div class="right">
          <img src="@/assets/images/rgjt.png" class="img" alt="">
        </div>
      </div> -->
      <div class="asset-links-item" @click="router.push('/loan')">
        <div class="left">
          <img src="@/assets/images/loan.svg" alt="" class="icon">
          <span class="link-text">{{ t('asset.a11') }}</span>
        </div>
        <div class="right">
          <img src="@/assets/images/rgjt.png" class="img" alt="">
        </div>
      </div>
      <!-- <div class="asset-links-item" @click="router.push('/loanRecords')">
        <div class="left">
          <img src="@/assets/images/zjjl.png" alt="" class="icon">
          <span class="link-text">贷款记录</span>
        </div>
        <div class="right">
          <img src="@/assets/images/rgjt.png" class="img" alt="">
        </div>
      </div> -->
      <div class="asset-links-item" @click="router.push('/fundPassword')">
        <div class="left">
          <img src="@/assets/images/mi2.svg" alt="" class="icon">
          <span class="link-text">{{ t('asset.a10') }}</span>
        </div>
        <div class="right">
          <img src="@/assets/images/rgjt.png" class="img" alt="">
        </div>
      </div>
    </div>
  </div>
  <!-- 交易选择 -->
  <TradeTypePopup :title="title" v-model="show" @select="handleSelect" :list="pageData.pay" />
</template>

<script setup name="assetPage">
import { formatUnit, exchangeRateConvert } from "@/utils/globalMethods"
import { showConfirmDialog } from "vant"
import { userAssets } from "@/api"
import { useRouter } from "vue-router";
import { onMounted, ref,onActivated, onDeactivated } from "vue";
import { useMainStore } from "@/store"
import { eventBus } from '@/utils/eventBus'
import { useI18n } from "vue-i18n"
const { t } = useI18n()

const router = useRouter()
const mainStore = useMainStore()
const rate = computed(() => mainStore.rate)
const active = ref(1)
const isShowAmount = ref(false)

const pageData = ref({
  "balance_ar": "0.00",
  "frozen_balance_ar": "0.00",
  "income_ar": "0.00",
  "stock_price_all": 0,
  "use_price": "0.00",
  "total_price": "0.00",
  "is_realname": 0,
  "pay": []
})
// 资产信息获取
const getPageData = () => {
  userAssets().then(res => {
    if (res.code == 200) {
      pageData.value = res.data
    }
  })
}
// 客服
const service = computed(() => mainStore.service)
const openService = () => {
  eventBus.emit("openService", service.value)
}

// 交易方式
const show = ref(false)
const title = ref('')
const tradeTypeVal = ref(1)
function handleSelect(obj) {
  // console.log(obj);

  // 提现是否实名
  if (pageData.value.is_realname == 0 && tradeTypeVal.value != 1) {
    showConfirmDialog({
      title: t('asset.c1'),
      confirmButtonColor: "#2969FF",
      confirmButtonText: t('asset.c2'),
      cancelButtonText: t('asset.c3'),
      // showCancelButton: false,
      message: t('asset.c4'),
    }).then(() => {
      router.push('/realNameAuthentication')
    })
    return
  }
  if (pageData.value.is_realname == 2 && tradeTypeVal.value != 1) {
    showConfirmDialog({
      title: t('asset.c1'),
      confirmButtonColor: "#2969FF",
      confirmButtonText: t('asset.c5'),
      cancelButtonText: t('asset.c3'),
      // showCancelButton: false,
      message: t('asset.c6'),
    }).then(() => {
      router.push('/realNameAuthentication')
    })
    return
  }
  // 跳转
  // console.log("选中：", type);
  if (obj.type == 'bank') { //银行卡
    if (tradeTypeVal.value == 1) { //银行卡充值
      router.push('/bankType?id=' + obj.item.id)
    } else {// 银行卡提现 
      router.push('/withdrawal')

    }
  } else {
    if (tradeTypeVal.value == 1) { //u充值充值
      router.push({
        path: '/topUp',
        query: {
          id: obj.item.id,
          name: obj.item.name
        }
      })
    } else { // u提现
      router.push({
        path: '/withdrawalu',
        query: {
          id: obj.item.id,
          name: obj.item.name
        }
      })
    }
  }

}
function tradeType(e) {
  tradeTypeVal.value = e
  if (e == 1) {
    title.value = t('asset.a12')
  } else {
    title.value = t('asset.a13')
  }
  show.value = true
}
function initPageApi(){
  getPageData()
}
onActivated(() => {
  initPageApi()
})
onDeactivated(() => {
  console.log('deactivated')
})
</script>
<style scoped lang="scss">
.page {
  min-height: 100vh;
  padding: 20px 20px 100px 20px;

  .asset-container {
    background: #fff;
    padding: 16px !important;

    .tabs {
      width: -moz-fit-content;
      width: fit-content;
      color: #999;
      font-size: 14px;
      display: flex;
      // box-shadow: 0 0 10px rgba(0, 0, 0, .05);
      border-radius: 4px;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 15px;

      .tabs-item {
        padding: 5px 16px;

        &.active {
          background: #2969FF;
          color: #fff;
          border-radius: 4px;
        }
      }
    }

    .all-asset-text {
      display: flex;
      gap: 20px;
      font-size: 15px;
      font-weight: 700;

      .item {
        flex: 1;
        margin: 16px 0;

        .all-asset-text-title {
          color: #333;
          font-family: Montserrat;
          font-size: 13px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;

          span {
            margin-left: 12px;
          }
        }

        .all-asset-text-value {
          color: #333;
          text-align: center;
          font-family: Montserrat;
          font-size: 20px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;

          .yval {
            font-size: 12px;
            color: #888c9f;
            margin-top: 3px;
            font-weight: 400;
          }
        }
      }
    }

    .list {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;

      .item {
        width: calc(50% - 10px);
        font-size: 12px;
      }

      .asset-echart-legend-item-container {
        display: flex;
        flex-direction: column;
        gap: 5px;
        padding: 14px 12px !important;
        border-radius: 4px;
        width: 100%;
      }

      .funds-value {
        font-size: 13px;
        font-weight: 700;
        font-family: Montserrat;

        .yval {
          font-size: 12px;
          color: #888c9f;
          margin-top: 3px;
          font-weight: 400;
        }
      }
    }
  }

  .asset-links {
    margin-top: 20px;

    .asset-links-item {
      background: #fff;
      margin: 14px 0;
      display: flex;
      padding: 12px 20px;
      align-items: center;
      border-radius: 8px;

      .left {
        display: flex;
        gap: 10px;
        align-items: center;

        .icon {
          width: 22px;
          height: 22px;
        }

        .link-text {
          font-size: 14px;
        }
      }

      .right {
        display: flex;
        flex: 1;
        justify-content: flex-end;

        .img {
          width: 8px;
          height: 14px;
        }
      }
    }
  }
}
</style>
